import React from 'react';

interface BeeLogChunk {
  type: 'start' | 'action' | 'plan' | 'suggestion' | 'done';
  timestamp: string;
  message: string;
  data?: Record<string, unknown>;
}

interface LogCardProps {
  log: BeeLogChunk[];
}

const LogCard: React.FC<LogCardProps> = ({ log }) => {
  const getChunkIcon = (type: string) => {
    switch (type) {
      case 'start': return '🚀';
      case 'action': return '⚡';
      case 'plan': return '📋';
      case 'suggestion': return '💡';
      case 'done': return '✅';
      default: return '📝';
    }
  };

  const getChunkColor = (type: string) => {
    switch (type) {
      case 'start': return 'bg-blue-100 border-blue-300';
      case 'action': return 'bg-yellow-100 border-yellow-300';
      case 'plan': return 'bg-purple-100 border-purple-300';
      case 'suggestion': return 'bg-green-100 border-green-300';
      case 'done': return 'bg-gray-100 border-gray-300';
      default: return 'bg-gray-50 border-gray-200';
    }
  };

  return (
    <div className="log-card p-4 border rounded-lg bg-gray-50">
      <h4 className="text-sm font-semibold mb-3 text-gray-700">Execution Log</h4>
      <div className="space-y-2">
        {log.map((chunk, index) => (
          <section 
            key={index} 
            className={`chunk chunk--${chunk.type} p-2 rounded border ${getChunkColor(chunk.type)}`}
          >
            <div className="flex items-center gap-2">
              <span className="text-lg">{getChunkIcon(chunk.type)}</span>
              <span className="text-sm font-medium capitalize">{chunk.type}</span>
              <span className="text-xs text-gray-500 ml-auto">
                {new Date(chunk.timestamp).toLocaleTimeString()}
              </span>
            </div>
            <p className="text-sm mt-1 text-gray-700">{chunk.message}</p>
          </section>
        ))}
      </div>
    </div>
  );
};

export default LogCard;
